var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<form class=\"\" id=\"form-upload-input\">\n    <div class=\"dialog-header bg-alizarin-90\">\n        <div class=\"icon bg-pomegranate\">\n            <i class=\"fa fa-times-circle\"></i>\n        </div>\n        <div class=\"header\">\n            ERROR\n            <div class=\"subheader\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + " Failed</div>\n        </div>\n    </div>\n    <div class=\"dialog-body-upload\" style=\"padding: 15px;\">\n        <div class=\"entry\">\n            <div class=\"media\">\n                <div class=\"media-body message\">\n                    \u003C!--<h4 class=\"media-heading\">Media heading</h4>-->\n                    "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"message") : depth0), depth0))
    + "\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"dialog-actions\">\n        <button type=\"submit\" class=\"error-submit\">"
    + alias2(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Close",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":22,"column":51},"end":{"line":22,"column":74}}}))
    + "</button>\n    </div>\n</form>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/dialog-error.hbs
// module id = qAVm
// module chunks = 1